import { DatePicker as AntdDatePicker, ConfigProvider } from 'antd'
import dayjs from 'dayjs'
import { Form } from 'react-bootstrap'

export default function DatePicker(props) {

    const { label_name, placeholder, name, value, minDate, onChange, onBlur, error, mandatory, reference, tabIndex } = props
    return (
        <>
            <Form.Group className="mb-2" controlId={name}>
                {label_name === '' ? '' : <Form.Label className={mandatory ? 'form_label_red' : 'form_label'}>{`${label_name}${mandatory ? '*' : ''}`}</Form.Label>}
                <ConfigProvider
                    theme={{
                        components: {
                            DatePicker: {
                                borderColor: 'hsl(0, 0%, 80%)',
                                activeBorderColor: '#436a53',
                                activeOutlineColor: 'none',
                                hoverBorderColor: 'none',
                                hoverBg: 'transparent',
                                activeShadow: 'none',
                                activeBg: 'transparent',
                                zIndexPopup: '99999',
                            },
                        },
                        token: {
                            colorBorder: '#ccc',
                            fontFamily: 'Lexend Deca'
                        },
                    }}
                >
                    <AntdDatePicker
                        ref={reference}
                        key={value}
                        className='form-control form_input'
                        placeholder={placeholder}
                        format={'DD/MM/YYYY'}
                        name={name}
                        defaultValue={value ? dayjs(value, 'DD/MM/YYYY') : ''}
                        disabledDate={(current) =>
                            minDate ? current && current.isBefore(dayjs(minDate, 'DD/MM/YYYY'), 'day') : false
                        }
                        onChange={onChange}
                        onBlur={onBlur}
                        tabIndex={tabIndex}
                    />
                </ConfigProvider>
                {error}
            </Form.Group>
        </>
    )
}
